module.exports = __webpack_public_path__ + "static/img/foundry_64.32107b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foundry_64.png
// module id = 3net
// module chunks = 0